import React, { createContext, useContext, useState, useEffect } from "react";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  // Load initial values from localStorage
  const rolePermissionValue = localStorage.getItem("rolePermissionList");
  const userTypeValue = localStorage.getItem("userType");
  const orgImageValue = localStorage.getItem("orgImage");

  const [rolePermissionList, setRolePermissionList] = useState(
    rolePermissionValue ? JSON.parse(rolePermissionValue) : []
  );
  const [userType, setUserType] = useState(userTypeValue ?? "");
  const [orgImage, setOrgImage] = useState(orgImageValue ?? "");

  // Persist rolePermissionList to localStorage whenever it changes
  useEffect(() => {
    console.log("[DEBUG] RolePermissionList updated:", rolePermissionList);
    localStorage.setItem("rolePermissionList", JSON.stringify(rolePermissionList));
  }, [rolePermissionList]);

  // Persist userType to localStorage whenever it changes
  useEffect(() => {
    console.log("[DEBUG] UserType updated:", userType);
    localStorage.setItem("userType", userType);
  }, [userType]);

  // Persist orgImage to localStorage whenever it changes
  useEffect(() => {
    console.log("[DEBUG] OrgImage updated:", orgImage);
    if (orgImage) {
      localStorage.setItem("orgImage", orgImage);
    }
  }, [orgImage]);

  // Utility function to check permission
  const checkPermission = (moduleName, permission) => {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === moduleName &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  };

  const value = {
    rolePermissionList,
    setRolePermissionList,
    userType,
    setUserType,
    orgImage,
    setOrgImage,
    checkPermission,
  };

  return (
    <GlobalContext.Provider value={value}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobal must be used within a GlobalProvider");
  }
  return context;
};
